import Header from "components/Headers/Header";
import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import img_checked from "assets/img/userImages/check_profile.png";
import img_account from "assets/img/userImages/account.png";
import img_account2 from "assets/img/userImages/account2.png";
import img_call from "assets/img/userImages/call.png";
import cleanleftlogo from "assets/img/userImages/cleanleftlogo.png";
import img_message from "assets/img/userImages/message.png";
import { get } from "utils/api";
import { Spinner } from "react-bootstrap";

export const UserProfile = () => {
  const { userId, role } = useParams();
  const [userData, setUserData] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const navigator = useNavigate();

  const handleViewOrderButton = () => {
    let queryParams = new URLSearchParams();
    queryParams.set("userId", userId);
    queryParams.set("role", role);
    let queryString = queryParams.toString();
    navigator(`/user/order?${queryString}`, {
      state: { currentService: false },
    });
  };
  const fetchApi = () => {
    setIsLoading(true);
    get(`api/admin/get/userDetail`, { userId })
      .then((res) => {
        setUserData(res.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };
  useEffect(() => {
    if (userId) {
      fetchApi();
    }
  }, [userId]);
  return (
    <>
      <Header />
      {isLoading ? (
        <Spinner animation="border" role="status">
          <span className="sr-only">Loading...</span>
        </Spinner>
      ) : userData ? (
        <>
          <div className=" container-fluid">
            <div className="row">
              <div className="col">
                <div className="main-box mt-0">
                  <div className="content-header">
                    <h3>{`${
                      userData?.first_name?.charAt(0).toUpperCase() +
                      userData?.first_name?.slice(1)
                    } ${
                      userData?.last_name?.charAt(0).toUpperCase() +
                      userData?.last_name?.slice(1)
                    }`}</h3>
                    {/* <a href="editprofile.html">
                Edit Profile <img src={img_editprofile} alt="Edit" />
              </a> */}
                  </div>
                  <div className="content-middle">
                    <div className="profile-sec">
                      <img
                        src={
                          userData?.profile_img
                            ? `${process.env.REACT_APP_BASE_URL}/${userData?.profile_img}`
                            : cleanleftlogo
                        }
                        alt="Image_Not_Found"
                      />
                    </div>
                    <div className="profile-content">
                      <ul>
                        <li>
                          <span>
                            <img src={img_account} alt="account" />
                            Profile
                          </span>
                          {userData?.userRoles
                            .map(
                              (role) =>
                                role.role_name.charAt(0).toUpperCase() +
                                role.role_name?.slice(1)
                            )
                            .join(", ")}
                        </li>
                        <li>
                          <span>
                            <img src={img_call} alt="call" />
                            Phone No.
                          </span>
                          {userData?.phone_number}
                        </li>
                        {/* <li>
                <span>
                  <img src={img_location} alt="message" />
                  Address
                </span>
                {userData?.userAddress.length > 0
                  ? `${userData?.userAddress?.address}  ${userData?.userAddress?.state}`
                  : "Not Provided"}
              </li> */}
                        <li>
                          <span>
                            <img src={img_account2} alt="account2" />
                            Account Formation Date
                          </span>
                          {`${new Date(userData?.createdAt).toLocaleDateString(
                            "en-US"
                          )}`}
                        </li>
                        <li>
                          <span>
                            <img src={img_message} alt="message" />
                            Email Address
                          </span>
                          <>
                            {userData?.email}
                            {userData?.is_email_verified ? (
                              <img
                                src={img_checked}
                                alt="approve"
                                className="img_checked"
                              />
                            ) : null}
                          </>
                        </li>
                        {/* <li>
                <span>
                  <img src={img_location_info} alt="message" />
                  Zip Code
                </span>
                {userData?.userAddress?.zip_code
                  ? userData?.userAddress?.zip_code
                  : "Not Provided"}
              </li> */}
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="main-box mt-4 mb-4">
                  <div className="box-header">
                    <div className="dual-btn">
                      <button
                        className="navbar-toggler"
                        type="button"
                        onClick={() => {
                          window.history.back();
                        }}
                      >
                        Go Back{" "}
                      </button>
                      <button
                        className="navbar-toggler"
                        type="button"
                        onClick={() => {
                          handleViewOrderButton();
                        }}
                      >
                        View Order History{" "}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <p>Data not found</p>
      )}
    </>
  );
};
